export default "__VITE_ASSET__y68qv0HC__"